import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [

      { path: '/', component: () => import('@/layout'),
        children: [
          { path: '/', component: () => import('@/components/home') },
          { path: '/inicio', component: () => import('@/components/inicio') },
          { path: '/diario', component: () => import('@/components/diario') },
          { path: '/ocorrencias', component: () => import('@/components/ocorrencias') },
          { path: '/acompanhamentos', component: () => import('@/components/acompanhamentos') },
          { path: '/materiais', component: () => import('@/components/materiais') },
          { path: '/calendario', component: () => import('@/components/calendario') },
          { path: '/cardapio', component: () => import('@/components/cardapio') },
          { path: '/mensagens', component: () => import('@/components/mensagens') },
          // BLOCO N — PAIS E ALUNOS (itens 2, 6, 7, 9, 10, 15, 17, 19)
          { path: '/horarios', component: () => import('@/components/horarios') },
          { path: '/aulas', component: () => import('@/components/aulas') },
          { path: '/frequencia', component: () => import('@/components/frequencia') },
          { path: '/matriculas', component: () => import('@/components/matriculas') },
          { path: '/rematricula', component: () => import('@/components/rematricula') },
          { path: '/atividades', component: () => import('@/components/atividades') }
        ],
      }
  ]
})

export default router
